import React from 'react';
import { motion } from 'framer-motion';
import { LinkIcon, PhoneCallIcon, WifiIcon } from 'lucide-react';
import { Section } from './Section';
import { painPoints } from '../data/content';
const icons = [LinkIcon, PhoneCallIcon, WifiIcon];
export function PainSection() {
  return <Section eyebrow="Cómo entran" title={<>
          Los delincuentes ya no necesitan ser genios de la computación. Solo necesitan{' '}
          <span className="text-alert-500" data-id="element-97" data-mp="2l7kgirf0cr5l">un pequeño error tuyo.</span>
        </>} data-id="element-96" data-mp="2yzqz0k5mva87">
      <ul className="grid gap-4 sm:grid-cols-3" data-id="element-98" data-mp="2pzc7h322syw9">
        {painPoints.map((point, index) => {
        const Icon = icons[index];
        return <motion.li key={point.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.4,
          delay: index * 0.08,
          ease: 'easeOut'
        }} className="rounded-xl border border-ink-700 bg-ink-800 p-5" data-id="element-99" data-mp="2bbzl5c4g2p4t" data-mpi={index}>
              <span className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-lg bg-alert-500/15 text-alert-500" data-id="element-100" data-mp="3rl7m829pe3xl">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-101" data-mp="5fsreqcip1eu" />
              </span>
              <h3 className="font-display text-base font-bold text-white" data-id="element-102" data-mp="5dq268j6vcb6">{point.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400" data-id="element-103" data-mp="emyarey3c4s">{point.description}</p>
            </motion.li>;
      })}
      </ul>

      <div className="mt-9 space-y-5 text-base leading-relaxed text-slate-300 sm:text-lg" data-id="element-104" data-mp="33xyeqjow5dfu">
        <p data-id="element-105" data-mp="3im2ogy5yuemh">
          Y en segundos tienen acceso a tus fotos, tus conversaciones privadas y lo más doloroso:{' '}
          <span className="font-semibold text-white" data-id="element-106" data-mp="3dvcipjtmo9r9">
            tus billeteras virtuales y cuentas bancarias.
          </span>
        </p>
        <p data-id="element-107" data-mp="2q47417zfbnij">
          La sensación de impotencia al ver tu cuenta en cero es algo que nadie debería pasar.
          Especialmente cuando se puede evitar con ajustes simples que las apps no te cuentan.
        </p>
      </div>
    </Section>;
}